const EXCLUDED_USER_TABLE_COLUMNS = new Set(["telephone", "cell", "fax"])

export function visibleUserTableColumns<T extends { key?: unknown; field?: unknown }>(
  columns: T[] | null | undefined,
  isHmcAdmin = false,
) {
  return (columns || []).filter((column) => {
    const key = String(column.key ?? column.field ?? "")
    if (key === "roles" && !isHmcAdmin) return false
    return !EXCLUDED_USER_TABLE_COLUMNS.has(key)
  })
}
